import { Builder, withGenericClick } from './with-utilities';

const onLinkClickBuilder: Builder = ({ ref, properties }) => {
  return {
    type: 'click-to-track-paperpal',
    destination: ref.getAttribute('href') ?? '',
    ...properties,
  };
};
export const withOnLinkClickTracking = withGenericClick(onLinkClickBuilder);
